<template>
  <header id="header" class="header d-flex align-items-center fixed-top">
    <div class="container position-relative d-flex align-items-center justify-content-between">
      <router-link :to="{ path: '/' }" class="logo d-flex align-items-center me-auto me-xl-0">
        <img src="../assets/img/LogoPlain.png" alt="MatrixHub Company Limited" />
        <h1 class="sitename">MatrixHub Co. Ltd.</h1>
      </router-link>
      <nav id="navmenu" class="navmenu">
        <ul @click="closeMobileNav">
          <li>
            <router-link to="/" :class="linkClass('/')">Home</router-link>
          </li>
          <li>
            <router-link to="/about" :class="linkClass('/about')">About</router-link>
          </li>
          <li>
            <router-link to="/how-we-work" :class="linkClass('/how-we-work')">How we Work!</router-link>
          </li>
          <li>
            <router-link to="/who-we-serve" :class="linkClass('/who-we-serve')">Who We Serve</router-link>
          </li>
          <li>
            <router-link to="/services" :class="linkClass('/services')">Services</router-link>
          </li>
          <li>
            <router-link to="/products" :class="linkClass('/products')">Products</router-link>
          </li>
          <li>
            <router-link to="/team" :class="linkClass('/team')">Team</router-link>
          </li>
          <li>
            <router-link to="/contact" :class="linkClass('/contact')">Contact</router-link>
          </li>
        </ul>
        <i
            class="mobile-nav-toggle d-xl-none bi"
            :class="isMobileNavActive ? 'bi-x' : 'bi-list'"
            @click="toggleMobileNav"
        ></i>
      </nav>
    </div>
  </header>
</template>

<script lang="ts">
import {defineComponent, ref, watch} from 'vue';
import {useRoute} from 'vue-router';

export default defineComponent({
  name: 'HeaderComponent',
  setup() {
    const route = useRoute();
    const isMobileNavActive = ref(false);

    const linkClass = (path: string) => {
      const active = path === '/' ? route.path === '/' : route.path.startsWith(path);
      return {
        active,
        'text-secondary': !active
      };
    };

    const toggleMobileNav = () => {
      isMobileNavActive.value = !isMobileNavActive.value;
      document.body.classList.toggle('mobile-nav-active', isMobileNavActive.value);
    };

    const closeMobileNav = () => {
      if (isMobileNavActive.value) {
        isMobileNavActive.value = false;
        document.body.classList.remove('mobile-nav-active');
      }
    };

    watch(() => route.fullPath, closeMobileNav);

    return {
      linkClass,
      isMobileNavActive,
      toggleMobileNav,
      closeMobileNav,
    };
  }
});
</script>
